/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketingDataDto } from '../../models/marketing-data-dto';

export interface UpdateMarketingDataByMerchant$Params {
  merchantId: string;
  marketingDataId: string;
      body: MarketingDataDto
}

export function updateMarketingDataByMerchant(http: HttpClient, rootUrl: string, params: UpdateMarketingDataByMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateMarketingDataByMerchant.PATH, 'put');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.path('marketingDataId', params.marketingDataId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateMarketingDataByMerchant.PATH = '/merchants/{merchantId}/marketing-data/{marketingDataId}';
